/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-06-28 01:04:04
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-22 21:55:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/validation/index.ts
 */
import { DATE_FORMAT } from '@/src/components/RangePicker';
import { linkValidation } from '@/src/constrains/DraggableModules/tools';
import moment from 'moment';

export const validationSingle = (data: any, popupWindows, isPrimary?) => {
  const { inUse, editing = [], previous = [], pending = [] } = popupWindows;
  //   判断时间存在不存在
  const {
    beginDate,
    beginTime,
    endDate,
    endTime,
    linkTo = {},
    image,
    remark,
    id,
    _status,
  } = data;
  if (_status === 'previous') {
    return { hasError: false, errors: [] };
  }
  //console.log('data', data);
  const remarkError = !![editing, ...inUse, ...previous, ...pending].find(
    (v) => v.remark === remark && v.id !== id,
  );
  const beginDateError = isPrimary
    ? validateTime(beginDate, beginTime)
    : { result: true };
  const endDateError = isPrimary
    ? validateTime(endDate, endTime)
    : { result: true };
  //   判断link
  const linkError = convertLinkError(linkValidation({ data: linkTo }));
  //   判断image存在不存在
  const imageError = validateImage(image);
  return {
    hasError:
      !beginDateError.result ||
      !endDateError.result ||
      !linkError.result ||
      !imageError.result ||
      remarkError,
    errors: [
      beginDateError.code,
      endDateError.code,
      linkError.code,
      imageError.code,
      remarkError ? 999981 : null,
    ].filter((v) => v),
  };
};

export const validateAll = (popupWindows, isPrimary) => {
  let errors = [];
  const { inUse, editing, previous, pending } = popupWindows;
  if (Array.isArray(inUse)) {
    const err = inUse.map((data) =>
      validationSingle(data, popupWindows, isPrimary),
    );
    errors = [...err];
  }
  if (Array.isArray(previous)) {
    const err = previous.map((data) =>
      validationSingle(data, popupWindows, isPrimary),
    );
    errors = [...errors, ...err];
  }
  if (Array.isArray(pending)) {
    const err = pending.map((data) =>
      validationSingle(data, popupWindows, isPrimary),
    );
    errors = [...errors, ...err];
  }

  if (Object.keys(editing).length !== 0) {
    const editingErr = validationSingle(editing, popupWindows, isPrimary);
    errors.push(editingErr);
  } else {
  }
  // const editingErr =
  //   Object.keys(editing).length !== 0
  //     ? validationSingle(editing, popupWindows, isPrimary)
  //     : { hasError: false };
  // errors.push(editingErr);
  const hasError = errors.reduce((a, b) => {
    return a.hasError || b.hasError;
  }, false);
  return hasError;
};

const validateTime = (date, time) => {
  if (!date || !time) {
    return { result: false, code: 999986 };
  }

  if (!moment(`${date} ${time}`, DATE_FORMAT).isValid()) {
    return { result: false, code: 999985 };
  }
  return { result: true };
};

const validateImage = (image: any) => {
  if (!image) {
    return { result: false, code: 999998 };
  }
  if (!image.uuid) {
    return { result: false, code: 199220 };
  }
  if (image.valid === false) {
    return { result: false, code: 199221 };
  }

  return { result: true };
};

const convertLinkError = (error: any) => {
  const { linkTypeError } = error;
  if (Array.isArray(linkTypeError)) {
    if (linkTypeError.length === 0) {
      return { result: true };
    } else {
      return { result: false, code: linkTypeError[0] };
    }
  }
};
